<label [for]="idVal" class="st-field-label">{{label}}</label>
<input [id]="idVal" class="form-control date-field" type="date" [ngStyle]="{
    'width': width
}"
       [value]="inputVal"
       [disabled]="this.disabled"
       />
<span id="startDateSelected"></span>
